import ServiceCRUD from '../../../../services/ServiceGasOrder';

class BranchService extends ServiceCRUD {
  constructor() {
    super(`/api/filiais`);
  }
}

export default new BranchService();
